import React from 'react';
import AccountPageTable from './accountPageTable';

const Accounts = (props) => {

  return (
      <AccountPageTable></AccountPageTable>
  );
}

export default Accounts;